export const files = {
    prodImgRoot: `${window.location.origin}/SiteCollectionImages/Erhverv/Kampagner/kampagner/`,
    prodCheckBoxImg: `${window.location.origin}/_layouts/15/images/RSA.Internet.CodanDK.UI/checkbox.png`,
    prodFontFamily: `${window.location.origin}/_layouts/15/RSA.Internet.CodanDK.UI/fonts/`,
    codanIcons: `${window.location.origin}/_layouts/15/images/rsa.internet.codandk.ui/icons/codan-icons.svg`, 

}